import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { SaleHorseRepoContactDto } from '../../models/sales/sale-contacts.model';
import { SaleHorse } from '../../models/sales/sale-horse.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { SaleContactListDataSource } from './sale-horse-repo-contact.datasource';

import { SalesService } from '../../services/sales.service';
@Component({
  selector: 'app-sale-horse-repo-contact-list',
  templateUrl: './sale-horse-repo-contact-list.component.html',
  styleUrls: ['./sale-horse-repo-contact-list.component.scss']
})
export class SaleHorseRepoContactListComponent extends BaseUnsubscribeComponent implements OnInit {

  @Input() public lotOrHipText: string;
  @Output() onDeleteContactEvent = new EventEmitter<SaleHorseRepoContactDto>();
  public dataSource: SaleContactListDataSource;
  private _searchTerm: string;
  public displayedColumns$ = new BehaviorSubject([
    'firstName',
    'lastName',
    'email',
    'mobile',
    'linkedLots',
    'action',
  ]);
  @Input() set searchTerm(value: string) {
    this._searchTerm = value;
    this.searchDataSource(value);
  }
  @ViewChild(MatSort) contactSort: MatSort;
  @Output() onContactEditEvent = new EventEmitter<SaleHorseRepoContactDto>();
  
  @Input() set contacts(value: SaleHorseRepoContactDto[]) {
    setTimeout(() => {
      // Every contact is rendered up front, so the scroll level must cover them all. At 20,
      // contacts 21+ were also queued as a next page that a scroll appended again (duplicate rows).
      this.dataSource = new SaleContactListDataSource(value || [], this.contactSort, true, Number.MAX_SAFE_INTEGER);
      this.searchDataSource(this._searchTerm);
    }, 100);
  }
  constructor(private readonly saleService: SalesService) {
      super();
  }

  private searchDataSource(searchTerm: string) {
    if (searchTerm == undefined || searchTerm == null) {
      return;
    }
    if (this.dataSource) {
      if (searchTerm === '') {
        this.dataSource?.clearFilter(); // Add a method to reset the data
      } else {
        this.dataSource.searchTable(searchTerm);
      }
    }
  }
  public onTableScroll(): void {
    this.dataSource.onScroll();
  }
  trackById(index: number, item: SaleHorseRepoContactDto): any {
    return item.repoContactId;
  }
  ngOnInit(): void {
  }

  public openContactPopup(contact: SaleHorseRepoContactDto) {
    this.onContactEditEvent.emit(contact);
  }

  public appendShareLinkPrefix(linkPostfix: string) {
    return `${window.location.origin}/${linkPostfix}`;
  }

  deleteContact(contact: SaleHorseRepoContactDto) {
    this.onDeleteContactEvent.emit(contact);
  }

}
